import { memo, useMemo } from "react";
import PropTypes from "prop-types";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";

import LinkListContainer from "./components/LinkListContainer";
import { StyledGrid } from "./styles";

const SubNavigation = memo(({ menuItem, mainMenuLinks, onLinkActiveChange }) => {
  const links = useMemo(() => MegaMenuItemPresenter.childrenMenu(menuItem), [menuItem]);

  return (
    <StyledGrid container>
      <LinkListContainer links={links} mainMenuLinks={mainMenuLinks} onLinkActiveChange={onLinkActiveChange} />
    </StyledGrid>
  );
});

SubNavigation.displayName = "SubNavigation";

SubNavigation.propTypes = {
  menuItem: MegaMenuItemPresenter.shape(),
  mainMenuLinks: PropTypes.arrayOf(PropTypes.string),
  onLinkActiveChange: PropTypes.func,
};

export default SubNavigation;
